import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ZendrPackage {
  type: string;
  width: number;
  height: number;
  length: number;
  count: number;
  weight: number;
  stackable: boolean;
  description: string;
}

export interface ZendrShipmentRequest {
  orderId: string;
  packages: ZendrPackage[];
}

@Injectable({
  providedIn: 'root'
})
export class ZendrService {
  private apiUrl = 'json/zendr/shipments';

  constructor(protected http: HttpClient) {}

  createShipment(request: ZendrShipmentRequest): Observable<any> {
    return this.http.post<any>(this.apiUrl, request);
  }
}
